import { ArrowUpRight } from "lucide-react";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { CAREERS } from "@/content/pages";

export default function Careers() {
  return (
    <PageShell testid="careers-root" seo={{
      title: "Careers — Sema",
      description: CAREERS.intro,
      keywords: "sema careers, jobs, remote engineering, data startup jobs",
      path: "/careers",
    }}>
      <PageHero testid="careers-h1" eyebrow="Careers"
        title="Build the governance layer for enterprise AI."
        subtitle={CAREERS.intro} />

      <section className="py-12">
        <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-5 px-6 md:grid-cols-3">
          {CAREERS.values.map((v) => (
            <div key={v.title} className="rounded-2xl border border-border/60 bg-card/50 p-7 backdrop-blur">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-accent/15 text-accent">
                <LucideIcon name={v.icon} className="h-5 w-5" />
              </span>
              <h3 className="mt-4 text-base font-semibold tracking-tight">{v.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-12">
        <div className="mx-auto w-full max-w-4xl px-6">
          <h2 className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">Open roles</h2>
          <div className="mt-6 divide-y divide-border/50 overflow-hidden rounded-2xl border border-border/60 bg-card/40">
            {CAREERS.roles.map((r) => (
              <a key={r.title} data-testid={`career-role-${r.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                href={`mailto:${CAREERS.email}?subject=${encodeURIComponent("Application: " + r.title)}`}
                className="group flex items-center justify-between gap-4 px-6 py-5 transition-colors hover:bg-background/50">
                <span>
                  <span className="block text-base font-medium tracking-tight">{r.title}</span>
                  <span className="mt-1 block font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground">{r.team} · {r.location} · {r.type}</span>
                </span>
                <span className="inline-flex items-center gap-1 font-mono text-[11px] uppercase tracking-[0.16em] text-accent">
                  Apply <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </a>
            ))}
          </div>
          <p className="mt-6 text-sm text-muted-foreground">
            Don't see your role? We're always glad to meet sharp people — email{" "}
            <a href={`mailto:${CAREERS.email}`} className="text-accent hover:underline">{CAREERS.email}</a>.
          </p>
        </div>
      </section>
    </PageShell>
  );
}
